export const USER_NOT_FOUND_EXCEPTION = 'UserNotFoundException';

export const INVALID_PARAMETER_EXCEPTION = 'InvalidParameterException';

export const MISSING_USERNAME = 'Username and pool information are required.';

export const USERNAME_ALREADY_EXISTS = 'UsernameExistsException';
